export default __webpack_public_path__ + "static/media/Archive.59ee8343.svg";